import React from 'react'
import blog1 from '../assets/blog1.jpg'
import blog2 from '../assets/blog2.jpg'
import blog3 from '../assets/blog3.jpg'

export const Blogs = () => {
    return (
        <div>
            {/* <!-- Blogs Section --> */}

            <section className="bg-[#021227] px-7 sm:px-14 py-16 max-w-screen-xl mx-auto" id="blogs">
                <div className="flex items-center justify-center gap-12 pb-12">
                    <div className="h-px flex-1 bg-[#309543] hidden sm:block"></div>
                    <h2 className="text-4xl font-bold ">Blogs</h2>
                    <div className="h-px flex-1 bg-[#309543] hidden sm:block"></div>
                </div>

                <div className="flex justify-center gap-1 flex-wrap lg:justify-between">

                    {/* <!-- blog 1 --> */}
                    <div className="md:max-w-[70%] lg:max-w-[30%] xl:max-w-sm bg-[#021227] rounded-lg border border-gray-800 shadow-md">
                        <a rel="noopener noreferrer">
                            <img className="rounded-t-lg hover:scale-110 duration-500" src={blog1} alt="prakash naikwadi blog 1" />
                        </a>
                        <div className="p-5">
                            <a rel="noopener noreferrer">
                                <h5 className="mb-2 text-2xl font-bold tracking-tight text-white-900">Scope, Scope Chain, and
                                    Lexical Environment In JavaScript.</h5>
                            </a>
                            <p style={{ fontFamily: "'Roboto', monospace;" }} className="mb-3 font-normal text-gray-500	 text-sm">
                                It provides extra security to our
                                variables by avoiding unwanted modifications from other parts of the program. It also gives us the pow...
                            </p>
                            <a
                                className="inline-flex items-center text-sm font-medium text-center text-[#309543] transition-all hover:text-[#fff]"
                                rel="noopener noreferrer">
                                Read more
                                <span className="hover:rotate-90 duration-300 animate-ping">
                                    <svg aria-hidden="true" className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </span>
                            </a>
                        </div>
                    </div>

                    {/* <!-- blog 2 --> */}
                    <div
                        className="md:max-w-[70%] lg:max-w-[30%] xl:max-w-sm mt-4 lg:mt-0 bg-[#021227] rounded-lg border border-gray-800 shadow-md">
                        <a rel="noopener noreferrer">
                            <img className="rounded-t-lg hover:scale-110 duration-500" src={blog2} alt="prakash blog img 2" />
                        </a>
                        <div className="p-5">
                            <a rel="noopener noreferrer">
                                <h5 className="mb-2 text-2xl font-bold tracking-tight text-white-900">How JavaScript Code Executes Internally
                                    -
                                    Execution Context.</h5>
                            </a>
                            <p style={{ fontFamily: "'Roboto', monospace;" }} className="mb-3 font-normal text-gray-500	 text-sm">
                                JavaScript is a scripting language and it requires a runtime environment to run and that runtime
                                environment
                                would be a web browser.
                            </p>
                            <a
                                className="inline-flex items-center text-sm font-medium text-center text-[#309543] transition-all hover:text-[#fff]"
                                rel="noopener noreferrer">
                                Read more
                                <span className="hover:rotate-90 duration-300 animate-ping">
                                    <svg aria-hidden="true" className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </span>
                            </a>
                        </div>
                    </div>

                    {/* <!-- blog 3 --> */}
                    <div
                        className="md:max-w-[70%] lg:max-w-[30%] xl:max-w-sm mt-4 lg:mt-0 bg-[#021227] rounded-lg border border-gray-800 shadow-md">
                        <a href="#" rel="noopener noreferrer">
                            <img className="rounded-t-lg hover:scale-110 duration-500" src={blog3} alt="prakash naikwadi blog 3" />
                        </a>
                        <div className="p-5">
                            <a rel="noopener noreferrer">
                                <h5 className="mb-2 text-2xl font-bold tracking-tight text-white-900">Learn MarkDown in 5 min</h5>
                            </a>
                            <p style={{ fontFamily: "'Roboto', monospace;" }} className="mb-3 font-normal text-gray-500	 text-sm">
                                We have all seen GitHub repositories readme.md file used for project explanation. In today's world, we
                                should explain our code through our readme files as no one...
                            </p>

                            <a className="inline-flex items-center text-sm font-medium text-center text-[#309543] transition-all hover:text-[#fff]"
                                rel="noopener noreferrer">
                                Read more
                                <span className="hover:rotate-90 duration-300 animate-ping">
                                    <svg aria-hidden="true" className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20"
                                        xmlns="http://www.w3.org/2000/svg">
                                        <path fill-rule="evenodd"
                                            d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                            clip-rule="evenodd"></path>
                                    </svg>
                                </span>
                            </a>

                        </div>
                    </div>



                </div>

                {/* <!-- more blogs --> */}
                <div className="text-end">
                    <a
                        className="flex items-center justify-end text-center pt-2 md:pr-[120px] lg:pr-0 text-xl font-medium text-[#309543] transition-all hover:text-[#fff]"
                        rel="noopener noreferrer">
                        More Blogs
                        <span className="hover:rotate-90 duration-300 animate-ping w-6 h-6">
                            <svg aria-hidden="true" className="ml-2 -mr-1 w-4 h-4" fill="currentColor" viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd"
                                    d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                    clip-rule="evenodd"></path>
                            </svg>
                        </span>
                    </a>
                </div>

            </section>
        </div>
    )
}
